/**
 * This function was accidentially exposed for mobile/native usage.
 *
 * @deprecated
 *
 * @return {string} Empty string.
 */
export default () => '';
